import AuthMixin from '@/components/mixins/auth-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'

export default {
  name: 'playerSearchBar',
  inject: [
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  compatConfig: {
    MODE: 3 // opt-in to Vue 3 behavior for this component only,
  },
  components: {},
  props: {
    presentPlayerListProp: {
      type: Object,
      default () { return {} }
    },
    playerSelectedFromParentProp: {
      default () { return [] }
    },
    tagsProp: {
      type: Array,
      default () { return [] }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    presentPlayerListProp (newVal) {
      this.presentPlayerListByBatch = newVal.batchHistory

      if (this.originalPresentPlayerListBeforeTheSearch !== null) {
        const originalPresentPlayerListBeforeTheSearch = this.$utils.clone(this.originalPresentPlayerListBeforeTheSearch)

        originalPresentPlayerListBeforeTheSearch.batchHistory.forEach((playerListByBatch) => {
          for (const indx in newVal.itemsToShow) {
            const currentPlayerItem = newVal.itemsToShow[indx]
            playerListByBatch = this.$utils.updateItemFromList(playerListByBatch, currentPlayerItem, 'serialNumber')
          }
        })

        for (const indx in newVal.itemsToShow) {
          const currentPlayerItem = newVal.itemsToShow[indx]
          originalPresentPlayerListBeforeTheSearch.itemsToShow = this.$utils.updateItemFromList(originalPresentPlayerListBeforeTheSearch.itemsToShow, currentPlayerItem, 'serialNumber')
        }

        this.originalPresentPlayerListBeforeTheSearch = originalPresentPlayerListBeforeTheSearch
      }
    },
    searchTextVal (val) {
      this.searchTextVal = val
      this.handlePreFlightSearchFromPresentData()
      this.confirmedSearchedValFlag = false
    },
    playerStatusSelected (val) {
      this.confirmedSearchedValFlag = false
    },
    playerSelectedFromParentProp: {
      handler (val) {
        this.playerSelectedFromParent = val
      },
      deep: true
    },
    tagsProp: {
      handler (newTagsVal) {
        this.tags = newTagsVal

        const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}
        if (selectedTagsFromSlider.playerPage && selectedTagsFromSlider.playerPage.length) {
          this.tags = selectedTagsFromSlider.playerPage
        } else {
          this.tags = []
        }

        if (this.tags.length <= 0) return

        if (this.originalPresentPlayerListBeforeTheSearch === null) {
          this.originalPresentPlayerListBeforeTheSearch = this.presentPlayerListProp
        }
        this.handlePreFlightSearchFromPresentData()

        // Fetch from backend if user has seconds idle time in type selection
        let timer = null
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.fetchPlayerListFromBackend({
            onKeyupIdleTimeRequest: true,
            callback: () => {
              this.$utils.mainLoader(false)
            }
          })
        }, this.idleTimeSearchingVal)
      },
      deep: true
    }
  },
  data () {
    return {
      error: '',
      searchStatus: { confirmedSearch: 'confirmedSearch', unConfirmedSearch: 'unConfirmedSearch' },
      originalPresentPlayerListBeforeTheSearch: null,
      presentPlayerListByBatch: this.presentPlayerListProp.batchHistory,
      playerSelectedFromParent: this.playerSelectedFromParentProp,
      enableSearchOptions: false,
      searchTextVal: '',
      searchResultsFromFrontend: { fullDetailsList: [], serialNumberList: [] },
      searchResultsFromBackend: { fullDetailsList: [] },
      searchResultsSummary: [],
      allowPlayerStatusSelectionInConfirmedSearch: false,
      playerStatusSelected: [],
      confirmedSearchedValFlag: false,
      idleTimeSearchingVal: 2000, // 2 seconds,
      mouseOverConfirmedText: false,
      tags: this.tagsProp
    }
  },
  mixins: [AuthMixin, OnEnterMixin],
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('player-search-bar-change', { action, payload: { data } })
      }
    },
    handleSearchIconClick () {
      if (this.presentPlayerListByBatch.length < 1) return
      useMixpanel().track('Search clicked')

      this.originalPresentPlayerListBeforeTheSearch = this.presentPlayerListProp
      this.enableSearchOptions = true
      this.$nextTick(_ => { this.$refs.playerSearchInput.focus() })
    },
    fetchPlayerListFromBackend (params) {
      const apiRequest = () => {
        const requestParams = { max: 30 }

        // Set search value
        if (this.searchTextVal !== '') {
          requestParams.search = this.searchTextVal
          useMixpanel().track('Search text')
        }

        // set tags
        if (this.tags.length > 0) {
          requestParams.tags = JSON.stringify(this.tags)
        }

        if (!params.onKeyupIdleTimeRequest) {
          this.$utils.mainLoader(false)
        }

        this.error = ''
        this.$api.get(`${CONFIG.API_BASE_URL}/player`, { params: requestParams })
          .then(response => {
            const newPlayerBatch = response.data.players
            const requestTags = response.config.params && response.config.params.tags ? response.config.params.tags : null
            const selectedTags = (Array.isArray(this.tags) && this.tags.length) ? JSON.stringify(this.tags) : null

            // Prepare nextFetch to send to parent
            const lastPlayerItem = newPlayerBatch[newPlayerBatch.length - 1]
            const nextFetch = {};

            if (response.data.nextToken) {
              nextFetch.moreItems = false
              nextFetch.exclusiveStartSerialNumber = null
              nextFetch.nextToken = response.data.nextToken
            } else if (lastPlayerItem.moreItems && lastPlayerItem.moreItems) {
              nextFetch.moreItems = true
              nextFetch.exclusiveStartSerialNumber = lastPlayerItem.serialNumber
              nextFetch.nextToken = null
            } else {
              nextFetch.moreItems = false
              nextFetch.exclusiveStartSerialNumber = null
              nextFetch.nextToken = null
            }

            /** Process search results
             - Request tags and current tags selection is the same
             - Make sure no selection have been made in parent component to avoid data refresh
             - Make sure current seach options is the same with the search options before the request to avoid flicker
            */
            if (requestTags === selectedTags) {
              if (params.onKeyupIdleTimeRequest) {
                if (!this.playerSelectedFromParent.length && (this.enableSearchOptions || this.tags.length > 0)) {
                  const prevSearchTextVal = (response.config.params.search) ? response.config.params.search : ''
                  const prevFileType = (response.config.params.type) ? response.config.params.type : ''
                  const currentSearchTextVal = this.searchTextVal
                  const currentFileType = this.playerStatusSelected.join(',')

                  if (prevSearchTextVal === currentSearchTextVal && prevFileType === currentFileType) {
                    this.searchResultsFromBackend.fullDetailsList = newPlayerBatch
                    this.sendSearchResultsToParent({
                      afterAPIRequest: true,
                      nextFetch
                    })
                  }
                }
              }

              if (!params.onKeyupIdleTimeRequest) {
                this.searchResultsFromBackend.fullDetailsList = newPlayerBatch
                this.sendSearchResultsToParent({
                  afterAPIRequest: true,
                  nextFetch
                })
              }
            }

            // Process callback
            if ((typeof (params) !== 'undefined') && (params.callback)) {
              params.callback()
            } else {
              this.$utils.mainLoader(false)
            }
          })
          .catch((error) => {
            this.error = error.message
            this.$utils.mainLoader(false)
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { apiRequest() } })
          })
      }
      apiRequest()
    },
    handleSearchConfirmation (actionType) {
      const searchTextVal = this.searchTextVal.trim()
      const hasSearchText = searchTextVal.length > 0
      const hasPlayerStatusSelected = this.playerStatusSelected.length > 0
      const isOnEnterOrOnBlur = ['onEnter', 'onBlur'].indexOf(actionType) >= 0
      const isOnSelectPlayerStatus = actionType === 'selectPlayerStatus'
      let searchFromBackend = false

      if (isOnEnterOrOnBlur) {
        if (!hasSearchText && !hasPlayerStatusSelected) {
          this.handleResetSearchValue()
          this.enableSearchOptions = false

          return
        }

        // If user click on the player type BEFORE entering any text, then apply the filter and let user type text
        if (hasSearchText && hasPlayerStatusSelected) {
          this.allowPlayerStatusSelectionInConfirmedSearch = true
          searchFromBackend = true
        }

        if (!hasSearchText && hasPlayerStatusSelected) {
          this.allowPlayerStatusSelectionInConfirmedSearch = true
          searchFromBackend = true
        }

        /* If the user enter some text and press enter, then show the files filters and if the user clicks on one of them,
        apply it together with the text previously entered by the user.  */
        if (hasSearchText && !hasPlayerStatusSelected) {
          this.allowPlayerStatusSelectionInConfirmedSearch = true
          searchFromBackend = true
        }
      }

      if (isOnSelectPlayerStatus) {
        if (!hasPlayerStatusSelected && !hasSearchText) {
          this.handleResetSearchValue()
          return
        }

        /* If the user click on the file type when some text have been entered, then validate the text and show the tag
          but let the files filter visible and apply the file filter the user
        */
        if (hasPlayerStatusSelected && hasSearchText) {
          this.allowPlayerStatusSelectionInConfirmedSearch = true
          searchFromBackend = true
        }
      }

      if (searchFromBackend && this.confirmedSearchedValFlag) {
        return
      }

      // Fetch from backend
      if (searchFromBackend) {
        this.confirmedSearchedValFlag = true
        this.fetchPlayerListFromBackend({
          callback: () => {
            this.$utils.mainLoader(false)

            if (this.playerStatusSelected.length === 0) {
              this.allowPlayerStatusSelectionInConfirmedSearch = true
            }
          }
        })
      }
    },
    /**
     * Handle client side search from present data fetch from backend or called as listByBatch
     */
    handlePreFlightSearchFromPresentData () {
      const dataSource = this.$utils.clone(this.originalPresentPlayerListBeforeTheSearch.batchHistory)
      const playerStatusSource = this.playerStatusSelected
      let preflightSearchResults = {
        fullDetailsList: [],
        serialNumberList: []
      }
      const searchText = this.searchTextVal.trim()
      const searchByName = (searchText.length > 0 && playerStatusSource.length === 0 && this.tags.length === 0)
      const searchByNameAndType = (searchText.length > 0 && playerStatusSource.length > 0 && this.tags.length === 0)
      const searchByNameAndTags = (searchText.length > 0 && playerStatusSource.length === 0 && this.tags.length > 0)
      const searchByNameAndTypeAndTags = (searchText.length > 0 && this.tags.length > 0 && this.tags.length > 0)
      const searchByFileType = (searchText.length === 0 && playerStatusSource.length > 0 && this.tags.length === 0)
      const searchByFileTypeAndTags = (searchText.length === 0 && playerStatusSource.length > 0 && this.tags.length > 0)
      const searchByTags = (searchText.length === 0 && playerStatusSource.length === 0 && this.tags.length > 0)
      const hasMultiTagSelection = this.tags.length > 1
      const hasSingleTagSelection = this.tags.length === 1
      const allPlayerFromEachBatch = {
        fullDetailsList: [],
        serialNumberList: []
      }

      for (const playerBatch of dataSource) {
        for (const playerItem of playerBatch) {
          const playerIncludesName = playerItem.name.toLowerCase().includes(searchText.toLowerCase())
          const playerIncludesStatus = (playerStatusSource.indexOf(playerItem.type) >= 0)
          let playerIncludesTag = false

          // Check tags
          if (!playerItem.tags) playerItem.tags = []

          if (hasMultiTagSelection) {
            playerIncludesTag = this.tags.every((selectedTag) => { return playerItem.tags.includes(selectedTag) })
          } else if (hasSingleTagSelection) {
            for (const indx in playerItem.tags) {
              if (this.tags[0] === playerItem.tags[indx]) {
                playerIncludesTag = true
                break
              }
            }
          } else {
            playerIncludesTag = false
          }

          let addToResult = false

          if (searchByName && playerIncludesName) { // Search by name
            addToResult = true
          } else if (searchByFileType && playerIncludesStatus) { // Search by type
            addToResult = true
          } else if (searchByTags && playerIncludesTag) {
            addToResult = true
          } else if (searchByNameAndType && (playerIncludesName && playerIncludesStatus)) {
            addToResult = true
          } else if (searchByNameAndTags && (playerIncludesName && playerIncludesTag)) {
            addToResult = true
          } else if (searchByFileTypeAndTags && (playerIncludesStatus && playerIncludesTag)) {
            addToResult = true
          } else if (searchByNameAndTypeAndTags && (playerIncludesName && playerIncludesStatus && playerIncludesTag)) {
            addToResult = true
          }

          if (addToResult) {
            preflightSearchResults.fullDetailsList.push(playerItem)
            preflightSearchResults.serialNumberList.push(playerItem.serialNumber)
          }

          // keep original list to send if no results
          allPlayerFromEachBatch.fullDetailsList.push(playerItem)
          allPlayerFromEachBatch.serialNumberList.push(playerItem.serialNumber)
        }
      }

      if (searchText.length === 0 && playerStatusSource.length === 0 && this.tags.length === 0) {
        preflightSearchResults = allPlayerFromEachBatch
      }

      this.searchResultsFromFrontend = preflightSearchResults
      this.searchResultsFromBackend = { fullDetailsList: [] }
      this.sendSearchResultsToParent()
    },
    sendSearchResultsToParent (params) {
      if (!this.enableSearchOptions && this.allowPlayerStatusSelectionInConfirmedSearch) {
        this.searchResultsFromFrontend = { fullDetailsList: [], serialNumberList: [] }
      }

      const searchResultsFromFrontend = this.$utils.clone(this.searchResultsFromFrontend)
      const searchResultsFromBackend = this.$utils.clone(this.searchResultsFromBackend)
      const searchResultsSummary = searchResultsFromFrontend

      searchResultsFromBackend.fullDetailsList.forEach((playerItemBackend) => {
        if (searchResultsFromFrontend.serialNumberList.indexOf(playerItemBackend.serialNumber) < 0) {
          searchResultsSummary.fullDetailsList.push(playerItemBackend)
          searchResultsSummary.serialNumberList.push(playerItemBackend.serialNumber)
        }
      })

      this.emitEvent('NEW_PLAYER_SEARCH_RESULTS', {
        searchResults: searchResultsSummary,
        reqSearchFilter: { search: this.searchTextVal, type: this.playerStatusSelected },
        afterAPIRequest: (typeof params === 'object' && params.afterAPIRequest) ?? null,
        nextFetch: (typeof params === 'object' && params.nextFetch) ?? null
      })
    },
    handleResetSearchValue () {
      this.searchTextVal = ''
      this.enableSearchOptions = true
      this.allowPlayerStatusSelectionInConfirmedSearch = false
      this.playerStatusSelected = []
      this.sendEventToParentToResetList()
    },
    sendEventToParentToResetList () {
      // Reset results from list history
      const originalPlayerList = this.$utils.clone(this.originalPresentPlayerListBeforeTheSearch)
      this.emitEvent('RESET_TO_ORIGINAL_LISTS', {
        originalPlayerList,
        reqSearchFilter: { search: null, type: [] }
      })
    },
    handleSearhOptionOnBlur () {
      const self = this
      $('#playerPage').on('click', (e) => {
        const targetElement = $(e.target)
        const preventConfirmedSearch = targetElement.hasClass('prevent-confirmed-search')
        const forceToCloseSearchOption = targetElement.hasClass('player-item-cover')

        if (self.enableSearchOptions && !preventConfirmedSearch && !forceToCloseSearchOption) {
          self.handleSearchConfirmation('onBlur')
        } else if (forceToCloseSearchOption) {
          if (self.searchTextVal.length > 0) {
            self.enableSearchOptions = true
          }
        }
      })
    },
    /**
     * Auto search from backend after seconds when user stop typing
     */
    handleAutoSearchFromBackendWhenStopTyping () {
      let timer = null
      this.$refs.playerSearchBar.onkeyup = () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.fetchPlayerListFromBackend({
            onKeyupIdleTimeRequest: true,
            callback: () => {
              this.$utils.mainLoader(false)
            }
          })
        }, this.idleTimeSearchingVal)
      }
    },
    // Auto search confirmation if press enter even if the input search field is not onFocus state
    handleSearchConfirmatioOnPagePressEnter () {
      const self = this
      $(document).keypress((event) => {
        const keycode = (event.keyCode ? event.keyCode : event.which)
        if (keycode.toString() === '13' && self.enableSearchOptions) {
          self.handleSearchConfirmation('onEnter')
        }
      })
    },
    handleConfirmedTextValueClick () {
      this.enableSearchOptions = true
    },
    onEnter (event) {
      if (event.target.id === 'player-search-input') {
        this.handleSearchConfirmation('onEnter')
      }
    }
  },
  mounted () {
    this.handleSearhOptionOnBlur()
    this.handleAutoSearchFromBackendWhenStopTyping()
    this.handleSearchConfirmatioOnPagePressEnter()
  }
}
